import React, { useState } from 'react'
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle'
import clsx from 'clsx'

interface Props extends DialogTitleProps {
    className?: string;
}

const DraggableDialogTitle: React.FC<Props> = ({ children, className, sx, ...props }) => {
    const [isDragging, setIsDragging] = useState(false)
    const handleMouseDown = () => setIsDragging(true)
    const handleMouseUp = () => setIsDragging(false)

    return (
        <DialogTitle
            className={clsx('draggable-title', className)}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            sx={{
                cursor: isDragging ? 'grabbing' : 'grab',
                userSelect: 'none',
                ...sx
            }}
            {...props}
        >
            {children}
        </DialogTitle>
    )
}

export default DraggableDialogTitle
